<template>
  <div>
    <div class="text-left">
      <strong>site.ini ({{ licenseData.usedSiteinis }} / {{ licenseData.allowedSiteinis }})</strong>
      <div class="progress">
        <div role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-warning" :style="{width: this.siteiniUsedPercent + '%'}"></div>
      </div>
    </div>
    <div class="text-left">
      <strong>Channels ({{ licenseData.usedChannels }} / {{ licenseData.allowedChannels }})</strong>
      <div class="progress">
        <div role="progressbar" aria-valuenow="30" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-info" :style="{width: this.channelsUsedPercent+ '%'}"></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    licenseData: {
      type: Object,
      default: function () {
        return {
          usedSiteinis: 0,
          usedChannels: 0,
          allowedSiteinis: 0,
          allowedChannels: 0
        }
      }
    }
  },
  computed: {
    siteiniUsedPercent: function () {
      const licenseData = this.licenseData;
      if (licenseData.allowedSiteinis > 0 && licenseData.usedSiteinis) {
        return (licenseData.usedSiteinis / licenseData.allowedSiteinis) * 100
      }
      return 0
    },
    channelsUsedPercent: function () {
      const licenseData = this.licenseData;
      if (licenseData.allowedChannels > 0 && licenseData.usedChannels) {
        return (licenseData.usedChannels / licenseData.allowedChannels) * 100
      }
      return 0
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Licenses/View/Stats.vue